export default __webpack_public_path__ + "static/media/54_mobile.1f81881b.jpg";